import { Stack, Typography } from '@mui/material';
import formatDate, { formatUtcDate } from '../../../../utils/formatDate';
import { COLORS, DATE_FORMATS } from '../../../../utils/Application_Constants';

const DateDescription = ({ title, value, showTime, isUtc }) => (
    <Stack gap={0.5} p={0.5} height="100%">
        <Typography
            color={COLORS.LT_MIDNIGHT50}
            fontSize={9}
            textTransform="uppercase"
            lineHeight="100%"
            fontWeight={600}
        >
            {title}
        </Typography>
        {value != null ? (
            <>
                <Typography
                    color={COLORS.LT_MIDNIGHT}
                    fontSize={14}
                    lineHeight="22px"
                    fontWeight={400}
                >
                    {isUtc
                        ? formatUtcDate(value, DATE_FORMATS.US_DATE)
                        : formatDate(value, { format: DATE_FORMATS.US_DATE })}
                </Typography>
                {showTime && (
                    <Typography
                        color={COLORS.LT_MIDNIGHT}
                        fontSize={12}
                        lineHeight="20px"
                        fontWeight={400}
                    >
                        {formatDate(value, { format: DATE_FORMATS.US_TIME })}
                    </Typography>
                )}
            </>
        ) : (
            <Typography
                color={COLORS.LT_MIDNIGHT}
                fontSize={14}
                lineHeight="22px"
                fontWeight={400}
                sx={{ marginBottom: 'auto' }}
            >
                No Date Available
            </Typography>
        )}
    </Stack>
);

export default DateDescription;
